module.exports = __webpack_public_path__ + "img/Tik-mark-red.fcb61434.png";